import React, {useState} from 'react';
import {BookedMeeting} from "../../interfaces/common";
import {Modal, ModalHeader, ModalBody, ModalFooter} from "../Modal";
import CustomButton from "../CustomButton";
import {calculateEndTime, dateFormatDate, dateFormatHourMinute} from "../../helpers/dateFunctions";
import iconCalendar from "url:shared-assets/icons/calendar.svg"
import iconClock from "url:shared-assets/icons/clock.svg";
import iconBadgeCheck from "url:shared-assets/icons/badge-check.svg";
import Api from "../../services/Api";

interface Props {
  meeting: BookedMeeting;
  close: Function
  lang: string
}

const CancelMeeting: React.FC<Props> = ({ meeting, close, lang }) => {
  const api = Api.getInstance();
  const [txt, setTxt] = useState<string>('');
  const [cancelled, setCancelled] = useState<boolean>(false);

  const doCancel = () => {
    const data = {
      id: meeting.id,
      message: txt
    }
    api.post('coach/meeting/cancel', data, ["meeting_not_found"]).then(response => {
      setCancelled(true);
    }).catch(response => {
      if (response.isExpectedError) {
        alert('We could not find this meeting. Reload page to see if meeting has already been removed')
      }
    })
  }

  const showContent = () => {
    if (cancelled) {
      return (
        <div>
          <div className="my-12 flex justify-center items-center">
            <img className="icon-xl" alt="check" src={iconBadgeCheck} />
          </div>
          <div className="text-neutral-300">
            {
              lang === 'sv' ? 'Ditt möte har avbokats och din klient uppdaterats.' :
                'Your meeting has been cancelled and your client is notified.'
            }

          </div>
        </div>
      )
    } else {
      const endTime = calculateEndTime(meeting.startDate, meeting.length)
      return (
        <div>
          <div className="font-medium">
            {meeting.firstName} {meeting.lastName}
          </div>
          <div className="mt-4 flex items-center">
            <img alt="calendar" className="icon" src={iconCalendar} />
            <div className="ml-2">{dateFormatDate(meeting.startDate, false, lang)}</div>
          </div>
          <div className="mt-4 flex items-center">
            <img className="icon" alt="Time" src={iconClock}/>
            <span className="ml-2">
                {dateFormatHourMinute(meeting.startDate)} - {dateFormatHourMinute(endTime)}
              </span>
          </div>

          <div className="mt-4">
            <textarea value={txt} className="z-input z-700 h-24"
                      placeholder={lang === 'sv' ? "Skriv meddelande till klienten..." :
                        "Write a message to the client..."}
                   onChange={(e) => setTxt(e.target.value)} autoComplete="off" />
          </div>
        </div>
      )
    }
  }

  return (
    <Modal isOpen={true} onClose={() => close(cancelled)}>
      <ModalHeader onClose={() => close(cancelled)}>
        {
          cancelled ? lang === 'sv' ? "Mötet har avbokats": "The meeting has been cancelled"
            : lang === 'sv' ? "Bekräfta avbokning" : "Confirm cancellation"
        }
      </ModalHeader>
      <ModalBody>
        <>
          {showContent()}
        </>
      </ModalBody>
      <ModalFooter>
        {
          cancelled ? (
            <CustomButton className="w-full" onClick={() => close(cancelled)}>Ok</CustomButton>
          ) : (
            <CustomButton className="w-full" onClick={() => doCancel()}>
              {lang === 'sv' ? 'Avboka möte' : 'Cancel meeting'}
            </CustomButton>
          )
        }
      </ModalFooter>
    </Modal>
  );
};

export default CancelMeeting;
